var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"directions-link",attrs:{"href":("https://www.google.com/maps/dir/?api=1&destination=" + _vm.address),"target":"_blank","rel":"noopener noreferrer"}},[_vm._v("Get directions")])}
var staticRenderFns = []

export { render, staticRenderFns }